import { z } from "zod";
import { CampaignOpportunityFieldsSchema } from "./CampaignOpportunity";
import { UserSchema } from "./User";

export const CampaignOpportunityChangelogSchema = z.object({
  id: z.number(),
  fieldType: z.number(),
  fieldName: z.string(),
  oldValue: z.any(),
  newValue: z.any(),
  modificationDate: z.string(),
  accountUser: z.any(),
  attribute: z.any(),
  campaignOpportunity: CampaignOpportunityFieldsSchema,
  userUser: UserSchema,
});
export const PartialCampaignOpportunityChangelogSchema =
  CampaignOpportunityChangelogSchema.deepPartial();

export type PartialCampaignOpportunityChangelog = z.infer<
  typeof PartialCampaignOpportunityChangelogSchema
>;

export type CampaignOpportunityChangelog = z.infer<
  typeof CampaignOpportunityChangelogSchema
>;
